import logoImage from "./images/zdrave-packy-logo.webp";
import leafTopLeftImage from "./images/flower-corner-3-1.webp";
import leafBottomRightImage from "./images/flower-corner-3-2.webp";
import cuteCatImage from "./images/cute-cat-1.webp";
import jenniferImage from "./images/jennifer-di-mauro.webp";
import initialConsultationImage from "./images/uvodni-konzultace.webp";
import manualTherapyImage from "./images/manualni-terapie.webp";
import massageImage from "./images/masaz.webp";
import shortTherapyImage from "./images/kratka-terapie.webp";
import longTherapyImage from "./images/dlouha-terapie.webp";
import laserUzvElectroImage from "./images/laser-uzv-elektroterapie.webp";
import magnetoTherapyImage from "./images/magnetoterapie.webp";

// Frontend-only mock data for Zdravé packy (no backend yet)
export const SITE = {
  name: "Zdravé packy",
  tagline: "Veterinární fyzioterapie zvířat",
  logoUrl: logoImage,
  // Always-on mascot (actual cat illustration, transparent)
  catStickerUrl: cuteCatImage,
  // Corner botanical leaves (transparent PNGs)
  leafTopLeft: leafTopLeftImage,
  leafBottomRight: leafBottomRightImage,
  bookingUrl: "https://app.vetnode.cz/zdrave-packy/booking",
  contacts: {
    instagram: "https://instagram.com/zdrave_packy_",
    facebook: "https://www.facebook.com/profile.php?id=61557372354822",
    email: "zdravepacky.dimauro@gmail.com",
    personalEmail: "ginevra.dimauro@gmail.com",
    phone: "+420 732 304 063",
  },
};

export const ABOUT = {
  image: jenniferImage,
  text:
    "Vítám všechny majitele čtyřnohých parťáků 🤗🐱🐶\n\nRáda bych se vám představila - jmenuji se Jennifer Di Mauro, narodila jsem se v Itálii a aktuálně sídlím v Petřvaldě u Nového Jičína.\n\nOd mého útlého věku jsem vyrůstala ve společnosti psů, koček, hospodářských zvířat a již tehdy jsem si byla jistá, že moje cesta půjde bezpochyby tímto směrem 🐰🐴🐱🐶.\n\nV roce 2014 jsem se za účelem středoškolského vzdělání v maturitním oboru veterinářství přestěhovala do České republiky a studovala 4 roky na TSOŠ veterinární v Kroměříži.\n\nBýt veterinární sestrou je nádherným povoláním, tudíž jsem se rozhodla prohloubit si dále své znalosti a praxi v oboru veterinární fyzioterapie zvířat. Slovo dalo slovo a v roce 2023 jsem se přihlásila na roční studium pod záštitou ASOFYREZ. Po úspěšném složení zkoušky a získání titulu cert.CAAPR jsem aktivně začala získávat praxi v oboru na pracovišti veterinární kliniky ABVet Bohumín, kde aktuálně pracuji.\n\nA nyní jsem tu pro vás a pro vaše čtyřnohé chlupaté kamarády, abych jim poskytla fyzioterapeutickou péči, kterou potřebují 🐾✅",
};

export const TEAM = [
  {
    id: "jennifer",
    name: "Jennifer Di Mauro",
    role: "Fyzioterapeut a rehabilitační pracovník malých zvířat, certifikace - certCAAPR",
    image: jenniferImage,
  },
  {
    id: "katerina-mrazkova",
    name: "Kateřina Mrázková",
    role: "",
    image: null,
  },
];

export const SERVICES = [
  {
    id: "initial-consultation",
    title: "Úvodní konzultace",
    duration: "",
    price: "1 000 Kč",
    image: initialConsultationImage,
    includesLabel: "Zahrnuje:",
    includes: [
      "Úvodní konzultace",
      "Fyzioterapeutické vyšetření pacienta",
      "Sestavení rehabilitačního plánu",
      "Prostor pro Vaše dotazy",
    ],
    keyPoints: [
      "Podrobná anamnéza a konzultace zdravotního stavu zvířete.",
      "Důkladné fyzioterapeutické vyšetření celého pohybového aparátu.",
      "Sestavení individuálního rehabilitačního plánu na míru.",
      "Doporučení pro domácí péči a zodpovězení veškerých dotazů.",
    ],
  },
  {
    id: "manual-therapy",
    title: "Manuální terapie",
    duration: "",
    price: "900 Kč",
    image: manualTherapyImage,
    isPortrait: true,
    includes: [
      "Osteodynamika",
      "Dornova metoda",
      "Čas ošetření 60-90 min",
    ],
    keyPoints: [
      "Manuální ošetření dle spolupráce psa a nálezů na pohybovém aparátu",
      "Ošetření pohybového aparátu pomocí manuálních technik",
      "Práce s měkkými tkáněmi a svaly",
      "Podpora správné pohyblivosti kloubů",
      "Uvolnění napětí",
      "Individuální přizpůsobení terapie konkrétnímu pacientovi",
      "Vhodné pro všechny věkové kategorie",
    ],
  },
  {
    id: "long-therapy",
    title: "Dlouhá terapie",
    duration: "do 60 min",
    price: "800 Kč",
    image: longTherapyImage,
    includes: [
      "Manuální techniky",
      "Aktivní/pasivní pohybovou terapii",
      "Kinesiotaping",
    ],
    keyPoints: [
      "Kombinace různých terapeutických metod vhodné pro vašeho psa – do 60 minut",
      "Aktivní a pasivní pohybová terapie",
      "Základní manuální ošetření",
      "Dlouhá hydroterapie",
      "Laserová terapie",
      "Vhodné po úrazech, operacích, pro aktivní a sportovní psy nebo pro seniory.",
    ],
  },
  {
    id: "massages",
    title: "Masáže",
    duration: "",
    price: "600 Kč",
    image: massageImage,
    isPortrait: true,
    includes: [
      "Masáž rekondiční",
      "Masáž relaxační",
      "Masáž fyzioterapeutickou",
    ],
    keyPoints: [
      "Manuální uvolnění ztuhlých svalů a fascií.",
      "Podpora pasivního rozsahu pohybu v kloubech.",
      "Podpora prokrvení tkání.",
      "Vhodné po úrazech, operacích, pro aktivní a sportovní psy nebo pro seniory.",
    ],
  },
  {
    id: "short-therapy",
    title: "Krátká terapie",
    duration: "do 30 min",
    price: "500 Kč",
    image: shortTherapyImage,
    isPortrait: true,
    includes: [
      "Manuální techniky",
      "Aktivní/pasivní pohybovou terapii",
      "Kinesiotaping",
    ],
    keyPoints: [
      "Kombinace různých terapeutických metod vhodné pro vašeho psa – do 30 minut",
      "Aktivní a pasivní pohybová terapie",
      "Základní manuální ošetření",
      "Krátká hydroterapie",
      "Laserová terapie",
      "Vhodné po úrazech, operacích, pro aktivní a sportovní psy nebo pro seniory.",
    ],
  },
  {
    id: "laser-uzv-electrotherapy",
    title: "Laser / UZV / Elektroterapie",
    duration: "",
    price: "300 Kč",
    image: laserUzvElectroImage,
    isPortrait: true,
    includes: [
      "Cena uvedena za jednorázovou aplikaci",
    ],
    subSections: [
      {
        title: "LASER",
        points: [
          "Cílené působení světelného paprsku pro stimulaci buněčné regenerace.",
          "Tlumení bolesti, zánětů a otoků (artróza, záněty šlach, pooperační stavy, úrazy).",
          "Zlepšení prokrvení tkání a podpora hojení.",
          "Zcela neinvazivní, bezbolestná a pro pejska nestresující procedura.",
        ],
      },
      {
        title: "UZV",
        points: [
          "Využívá tepelného účinku ultrazvukového vlnění.",
          "Zlepšení prokrvení tkání a podpora hojení.",
          "Vhodný k řešení kontraktur (zkrácení svalů).",
        ],
      },
      {
        title: "ELEKTROTERAPIE",
        points: [
          "Aktivace a posílení svalů.",
          "Prevence svalové atrofie (slabosti).",
          "Stimulace nervosvalového systému.",
        ],
      },
    ],
  },
  {
    id: "magnetotherapy",
    title: "Magnetoterapie",
    duration: "",
    price: "200 Kč",
    image: magnetoTherapyImage,
    isPortrait: true,
    imagePosition: "center 85%",
    includes: [
      "Cena uvedena za den zapůjčení do domácí péče",
    ],
    keyPoints: [
      "Neinvazivní metoda využívající léčivé pulzní magnetické pole.",
      "Podpora prokrvení tkání, tlumení zánětů a urychlení buněčného hojení.",
      "Úleva od bolesti kloubů, při artróze, po úrazech, pooperačních stavech a neurologických potížích.",
      "Možnost zapůjčení přístroje do domácí péče pro každodenní aplikaci.",
    ],
  },
];

export const FAQ = [
  {
    q: "Jak se připravit na první návštěvu?",
    a: "Vezměte si zdravotní dokumentaci zvířete a krátce popište potíže. Před terapií 2 hodiny nekrmit.",
  },
  {
    q: "Je nutné doporučení od veterináře?",
    a: "Není nutné, ale spolupráce s vaším veterinářem je vítaná a prospěšná.",
  },
  {
    q: "Kde nás najdete?",
    a: (
      <div className="flex flex-col gap-4 mt-2">
        <span>Najdete nás na adrese: <strong>Jateční 1202, 735 51 Nový Bohumín</strong></span>
        <iframe
          loading="lazy"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2569.687689784284!2d18.344111576892583!3d49.904666426510595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47115789f49e64eb%3A0xa6b1281738d4b7c5!2sABvet%20veterinary%20klinika-%20MVDr.Martin%20Novak!5e0!3m2!1sen!2scz!4v1772050879576!5m2!1sen!2scz"
          title="Location Map"
          aria-label="Location Map"
          className="w-full h-64 border-0 rounded-md"
        ></iframe>
      </div>
    ),
  },
];